import { CompanyAPI } from '@api';

const saveBus = (form) => CompanyAPI.saveBus(form)
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response?.data || error.response));

export { saveBus };
